export default __webpack_public_path__ + "static/media/organization-select.cc1dd90c.png";